document.addEventListener('DOMContentLoaded', function () {
  var splideElems = document.querySelectorAll('.mm-splide-collection-grid');
  var bar = document.querySelector('.my-carousel-progress-bar-collection-grid');

  splideElems.forEach(function(splideElem) {
    var bar = splideElem.querySelector('.my-carousel-progress-bar-collection-grid');
    var splide = new Splide(splideElem, {
      type: 'slide',
      arrows: false,
      pagination: false,
      fixedWidth: 265,
      perPage: 3,
      perMove: 2,
      gap: 16,
      omitEnd: true,
      padding: {
        left: 15,
        right: 15
      },
      breakpoints: {
        768: {
          perPage: 1,
          perMove: 1,
          padding: {
            left: 15,
            right: 15
          },
        }
      }
    }).mount();

    splide.on('mounted move', function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });
  });
  });


